import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={33} height={32} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M25.386 13a1 1 0 110 2h-14a1 1 0 110-2h14zM25.302 9a1 1 0 110 2h-18a1 1 0 110-2h18zM25.302 17a1 1 0 110 2h-18a1 1 0 110-2h18zM25.386 21a1 1 0 110 2h-8.801a1 1 0 110-2h8.801z" fill="#000" /></svg>;
}
export default SvgComponent;